import { render, staticRenderFns } from "./CloseBatchErrorModal.vue?vue&type=template&id=50464eab&scoped=true"
import script from "./CloseBatchErrorModal.vue?vue&type=script&lang=js"
export * from "./CloseBatchErrorModal.vue?vue&type=script&lang=js"
import style0 from "./CloseBatchErrorModal.vue?vue&type=style&index=0&id=50464eab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50464eab",
  null
  
)

export default component.exports